import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TipoVeiculoService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getTiposVeiculo(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposveiculo' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getTipoVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaTipoVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/tiposveiculo', {
				tipo_veiculo_nome: data.tipo_veiculo_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaTipoVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/tiposveiculo/' + data.tipo_veiculo_id, {
				tipo_veiculo_nome: data.tipo_veiculo_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaTipoVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/tiposveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
